import { Box, Chip, Paper, Typography, useTheme } from "@mui/material";
import LogoImage from "../../images/logo/logo.png";
import { APP_NAME } from "../../constants/brand";

function TeacherAuthLayout({
    title,
    subtitle,
    sideTitle,
    sideSubtitle,
    children,
    footer,
    sideImage,
    isAr = true,
}) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: "100vh",
                background:
                    theme.palette.mode === "dark"
                        ? "linear-gradient(180deg, #0f172a 0%, #111827 100%)"
                        : "linear-gradient(180deg, #eef4ff 0%, #f8fbff 100%)",
            }}
        >
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", lg: "minmax(480px, 620px) 1fr" },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        p: { xs: 2, sm: 3, md: 4 },
                    }}
                >
                    <Paper
                        elevation={0}
                        sx={{
                            width: "100%",
                            maxWidth: 560,
                            borderRadius: 5,
                            overflow: "hidden",
                            border: "1px solid",
                            borderColor: theme.palette.mode === "dark" ? "divider" : "rgba(148,163,184,0.22)",
                            bgcolor: theme.palette.background.paper,
                            boxShadow:
                                theme.palette.mode === "dark"
                                    ? "0 20px 45px rgba(0,0,0,0.35)"
                                    : "0 24px 60px rgba(15,23,42,0.12)",
                        }}
                    >
                        <Box
                            sx={{
                                p: { xs: 3, sm: 4, md: 5 },
                                display: "flex",
                                flexDirection: "column",
                                gap: 3,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 2,
                                    flexWrap: "wrap",
                                }}
                            >
                                <Chip
                                    label={isAr ? "لوحة المعلم" : "Teacher dashboard"}
                                    sx={{
                                        bgcolor: "rgba(13,53,140,0.1)",
                                        color: "#0D358C",
                                        fontWeight: 700,
                                    }}
                                />
                                <Box className="auth-logo-card" sx={{ m: 0 }}>
                                    <Box
                                        component="img"
                                        src={LogoImage}
                                        alt={APP_NAME}
                                        className="auth-logo"
                                    />
                                </Box>
                            </Box>

                            <Box>
                                <Typography
                                    variant="h4"
                                    fontWeight={900}
                                    sx={{
                                        color: "#0D358C",
                                        lineHeight: 1.15,
                                        fontSize: { xs: "1.9rem", sm: "2.25rem" },
                                    }}
                                >
                                    {title}
                                </Typography>
                                {subtitle ? (
                                    <Typography
                                        variant="body1"
                                        sx={{ mt: 1.25, color: "text.secondary", lineHeight: 1.8 }}
                                    >
                                        {subtitle}
                                    </Typography>
                                ) : null}
                            </Box>

                            {children}

                            {footer ? (
                                <Box
                                    sx={{
                                        pt: 2,
                                        borderTop: "1px solid",
                                        borderColor: theme.palette.mode === "dark" ? "divider" : "#e2e8f0",
                                    }}
                                >
                                    {footer}
                                </Box>
                            ) : null}
                        </Box>
                    </Paper>
                </Box>

                <Box
                    sx={{
                        display: { xs: "none", lg: "block" },
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        component="img"
                        src={sideImage}
                        alt=""
                        sx={{
                            position: "absolute",
                            inset: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                        }}
                    />
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            background:
                                "linear-gradient(145deg, rgba(13,53,140,0.88) 0%, rgba(29,78,216,0.62) 45%, rgba(15,23,42,0.72) 100%)",
                        }}
                    />
                    <Box
                        sx={{
                            position: "relative",
                            zIndex: 1,
                            height: "100%",
                            display: "flex",
                            alignItems: "flex-end",
                            p: 6,
                        }}
                    >
                        <Box sx={{ maxWidth: 420, color: "white" }}>
                            <Typography variant="h3" fontWeight={900} sx={{ lineHeight: 1.15, mb: 2 }}>
                                {sideTitle}
                            </Typography>
                            <Typography sx={{ opacity: 0.92, lineHeight: 1.9 }}>
                                {sideSubtitle}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default TeacherAuthLayout;
